/** @type {import('tailwindcss').Config} */

module.exports = {
  corePlugins: {
    preflight: false,
  },
  content: ['./src/**/*.{js,ts,jsx,tsx,mdx}'],
  theme: {
    scale: {
      66: '0.666', // 66.6%로 줄이기
    },
    screens: {
      sm: '640px',
      md: '768px',
      lg: '916px',
      pc: '916px',
      xl: '1280px',
    },
    fontWeight: {
      thin: '100',
      'extra-light': '200',
      light: '300',
      normal: '400',
      regular: '400',
      medium: '500',
      'semi-bold': '600',
      bold: '700',
      'extra-bold': '800',
      black: '900',
    },
    fontSize: {
      xxxs: ['12px', '18px'],
      xxs: ['14px', '21px'],
      xs: ['16px', '24px'],
      sm: ['18px', '27px'],
      md: ['20px', '30px'],
      lg: ['22px', '33px'],
      xl: ['24px', '36px'],
      xxl: ['26px', '39px'],
      xxxl: ['28px', '42px'],
    },
    extend: {
      height: {
        nav: '56px',
      },
      width: {
        body: '800px',
        nav: '300px',
        content: '732px',
      },
      spacing: {
        'dynamic-gap': 'var(--dynamic-gap)',
      },
      colors: {
        DirittoGreen: '#CBDFC7',
        Kakao: '#FEE500',
        Naver: '#03C75A',
        Twitter: '#1DA1F2',
        SepiaBg: '#F6F1E5',
        DarkGrayBg: '#484848',
        DarkBg: '#1A1A1A',
        DarkGrayTxt: '#D4D4D4',
        BlackTxt: '#ABABAB',

        Secondary500: '#00CDFF',
        Error500: '#FF4B78',
        Warning500: '#FF8700',
        Success500: '#00D2A0',
        Yellow: '#FCC939',
        Tertiary500: '#06E4F9',
        White: '#FFFFFF',
        Black: '#000000',

        gray: {
          100: '#F6F8FA',
          200: '#EAEEF2',
          300: '#D0D7DE',
          400: '#AFB8C1',
          500: '#8C959F',
          600: '#6E7781',
          700: '#57606A',
          800: '#424A53',
          900: '#32383F',
          1000: '#24292f',
        },
        primary: {
          100: '#F4EFFF',
          200: '#DBCBFF',
          300: '#C2A7FF',
          400: '#AA83FF',
          500: '#915FFF',
          600: '#7749DD',
          700: '#6036BB',
          800: '#4A2699',
          900: '#361877',
          1000: '#240E55',
        },
        blue: {
          100: '#E5F4FF',
          200: '#B7DFFF',
          300: '#89CBFF',
          400: '#5CB7FF',
          500: '#2EA3FF',
          600: '#0089F4',
          700: '#0072CB',
          800: '#005BA2',
          900: '#00447A',
          1000: '#002D51',
        },
        yellow: {
          100: '#FFF8C5',
          200: '#FAE17D',
          300: '#EAC54F',
          400: '#D4A72C',
          500: '#BF8700' /* BEFORE YELLOW */,
          600: '#9A6700',
          700: '#7D4E00',
          800: '#633C01',
          900: '#4D2D00',
          1000: '#3B2300',
        },
        orange: {
          100: '#FFF1E5',
          200: '#FFD8B5',
          300: '#FFB77C',
          400: '#FB8F44',
          500: '#E16F24',
          600: '#BC4C00',
          700: '#953800',
          800: '#762C00',
          900: '#5C2200',
          1000: '#471700',
        },
        red: {
          100: '#FFEBE9',
          200: '#FFCECB',
          300: '#FFABA8',
          400: '#FF8182',
          500: '#FA4549',
          600: '#CF222E',
          700: '#A40E26',
          800: '#82071E',
          900: '#660018',
          1000: '#4C0014',
        },
        green: {
          100: '#DAFBE1',
          200: '#ACEEBB',
          300: '#6FDD8B',
          400: '#4AC26B',
          500: '#2DA44E',
          600: '#1A7F37',
          700: '#116329',
          800: '#044F1E',
          900: '#003D16',
          1000: '#002D11',
        },
        borderRadius: {
          md: '4px',
        },
      },
    },
  },
  plugins: [
    function ({ addUtilities }) {
      addUtilities({
        '.dynamic-gap': {
          gap: 'var(--dynamic-gap)',
        },
        '.dynamic-gap-x': {
          'column-gap': 'var(--dynamic-gap-x)',
        },
        '.dynamic-gap-y': {
          'row-gap': 'var(--dynamic-gap-y)',
        },
        '.dynamic-w': {
          width: 'var(--dynamic-w)',
        },
        '.dynamic-h': {
          height: 'var(--dynamic-h)',
        },
      });
    },
  ],
  variants: {},
};
